module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"series":"バージョン","name":"曲名","difficulty":"難易度","level":"レベル","edit":"スコア編集","noData":"データがありません"},"en":{"series":"Series","name":"Name","difficulty":"Difficulty","level":"Lv","edit":"Edit Score","noData":"No data"}}')
  delete Component.options._Ctor
}
